<template>
    <section class="partners">
        <div class="container">
            <h2 class="title">{{ $t('technologies.partnersTitle') }}</h2>
            <div class="partners__brands">
                <img src="/images/microsoft.svg" alt="Microsoft">
                <img src="/images/nvidia.svg" alt="Nvidia">
                <img v-if="isRussianIP" src="/images/skolkovo.svg" alt="Skolkovo">
            </div>
        </div>
    </section>
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        computed: {
            ...mapState(['isRussianIP'])
        }
    }
</script>